module.exports = __webpack_public_path__ + "img/close-light.97f78649.svg";